/**
 * Chart theme tokens and series styling.
 * Reads --chart-1..8, --chart-grid, and --chart-axis CSS variables.
 * More than 8 series reuse colors with a dashed pattern (index >= 8).
 * Pure token-based — zero hex literals.
 */

export const CHART_THEME_COLORS = [
  'var(--chart-1)',
  'var(--chart-2)',
  'var(--chart-3)',
  'var(--chart-4)',
  'var(--chart-5)',
  'var(--chart-6)',
  'var(--chart-7)',
  'var(--chart-8)',
] as const

export const CHART_GRID_COLOR = 'var(--chart-grid)'
export const CHART_AXIS_COLOR = 'var(--chart-axis)'
export const CHART_TEXT_PRIMARY = 'var(--text-primary)'
export const CHART_TEXT_SECONDARY = 'var(--text-secondary)'
export const CHART_SURFACE = 'var(--surface)'

export interface SeriesStyle {
  color: string
  fill: string
  strokeDasharray?: string
  isDashed: boolean
}

/**
 * Returns series color and dashed pattern.
 * If customColor is provided, uses it; otherwise cycles through theme colors.
 * Series at index 8 and higher get a dashed stroke pattern (4 4).
 */
export function getSeriesStyle(seriesIndex: number, customColor?: string): SeriesStyle {
  const color = customColor || CHART_THEME_COLORS[seriesIndex % CHART_THEME_COLORS.length]
  const isDashed = seriesIndex >= 8
  return {
    color,
    fill: color,
    strokeDasharray: isDashed ? '4 4' : undefined,
    isDashed,
  }
}
